import { useMemo } from "react";
import { useInView } from "../../hooks/useInView";
import { useCmsLink } from "../../hooks/useCmsLink";
import { useHomePage } from "../../context/HomePageContext";
import { useLanguage } from "../../context/LanguageContext";
import { resolveAbout } from "../../lib/homePageContent";
import "../../style/animations.css";

export default function AboutPreviewSection() {
  const { ref, inView } = useInView<HTMLDivElement>();
  const goTo = useCmsLink();
  const { data } = useHomePage();
  const { language } = useLanguage();
  const about = useMemo(() => resolveAbout(data?.about, language), [data, language]);

  return (
    <section
      className="
        w-full

        px-6
        py-20

        lg:px-20
      ">
      <div
        ref={ref}
        className="
          relative

          w-full
          max-w-[1327px]

          mx-auto

          overflow-hidden

          rounded-[32px]

          min-h-[420px]

          lg:min-h-[450px]
        ">
        {/* BACKGROUND IMAGE */}
        <img
          src={about.image}
          alt="worker"
          className={`
    absolute
    inset-0

    w-full
    h-full

    object-cover

    lg:left-[420px]
    lg:w-[950px]

    transition-transform
    duration-[1200ms]
    ease-out

    ${inView ? "scale-100" : "scale-110"}
  `}
        />

        {/* DARK OVERLAY */}
        <div
          className="
    absolute
    inset-0

    bg-black/35

    lg:bg-black/10

    z-10
  "
        />

        {/* GRADIENT */}
        <div
          className="
    absolute
    inset-0

    bg-[linear-gradient(180deg,rgba(0,0,0,0.55)_0%,rgba(61,164,168,0.70)_100%)]

    lg:bg-[linear-gradient(270deg,rgba(61,164,168,0)_34%,#3DA4A8_62%)]

    z-10
  "
        />

        {/* CONTENT */}
        <div
          className="
            relative
            z-20

            h-full

            flex
            items-center

            px-8
            py-12

            lg:px-12
          ">
          <div
            className={`
              reveal-left
              ${inView ? "is-visible" : ""}

              max-w-[420px]

              text-white
            `}>
            {/* LABEL */}
            <span
              className="
                text-[14px]

                font-medium

                block
                mb-6

                mt-2
              ">
              {about.label}
            </span>

            {/* DESCRIPTION */}
            <div
              className="
                space-y-7

                text-[15px]
                leading-[30px]

                lg:text-[16px]
                lg:leading-[30px]
              ">
              {about.paragraphs.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>

            {/* BUTTON */}
            {about.buttonLabel && (
            <button
              onClick={() => goTo(about.buttonLink)}
              className="
                mt-12

                w-[150px]
                h-[46px]

                rounded-full

                border
                border-white/40

                bg-white/10

                backdrop-blur-sm

                text-[15px]
                font-medium
                text-white

                transition-all
                duration-300

                hover:bg-white
                hover:text-[#2C4858]
                hover:scale-[1.05]
                active:scale-95
              ">
              {about.buttonLabel}
            </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
